import { __assign } from "tslib";
import * as React from 'react';
import { Select } from '../../Select';
var SelectWidget = function (props) {
    var _a;
    var id = props.id, options = props.options, value = props.value, disabled = props.disabled, readonly = props.readonly, onChange = props.onChange;
    var enumOptions = options.enumOptions, enumDisabled = options.enumDisabled;
    var selectOptions = (_a = enumOptions) === null || _a === void 0 ? void 0 : _a.map(function (option) {
        return __assign(__assign({}, option), { disabled: enumDisabled && enumDisabled.indexOf(option.value) !== -1 });
    });
    return (React.createElement(Select, { width: "100%", id: id, value: value ? selectOptions.find(function (option) { return option.value === value; }) : '', disabled: disabled || readonly, onChange: function (_a) {
            var option = _a.option;
            onChange(option.value);
        }, options: selectOptions, emphasized: options.emphasized, valueKey: "value", labelKey: "label", disabledKey: "disabled" }));
};
export default SelectWidget;
